<h2 matDialogTitle class="start-xs">{{ data.title }}</h2>
<mat-dialog-content>
  <div [innerHTML]="data.content"></div>
</mat-dialog-content>
<mat-dialog-actions
  align="end"
  [class.inline]="data.button2"
  [class.block]="!data.button2"
>
  <button
    class="btn-retiro active last"
    *ngIf="data.button2"
    (click)="close(data.button2.value)"
  >
    {{ data.button2.label }}
  </button>
  <button
    class="btn-retiro active first"
    *ngIf="data.button1"
    (click)="close(data.button1.value)"
  >
    {{ data.button1.label }}
  </button>
</mat-dialog-actions>
